import { ILineAction, ILines } from "./lineReducer";

export function setActiveLine(name: string): ILineAction {
    return {
        type: "PROGRESS_LINE_UPDATE",
        payload: { activeName: name }
    }
}



export function updateLines(lines: ILines): ILineAction {
    return {
        type: "PROGRESS_LINE_UPDATE",
        payload: { lines: lines }
    }
}

export function clearProgress(): ILineAction {
    return {
        type: "CLEAR_PROGRESS",
    }
}